import moment from 'moment';
import { Link } from 'react-router';
import { Box, Column, Row, Text } from '~/commonComponents';
import { UserProfession } from '~/enums/UserProfession';
import { Colors } from '~/themes/colors';
import { IProfessionalCardUser } from '../../interfaces';
import { ProfessionalRating } from '../ProfessionalRating';

interface IProfessionalCardDetailsProps {
  user: IProfessionalCardUser;
}

export const ProfessionalCardDetailsLegacy = ({ user }: IProfessionalCardDetailsProps) => {
  const { id, fullname, datetime, profession, rating, isAvailable } = user;
  const isToday = moment(datetime).isSame(moment(), 'day');
  const unavailableColorText = isAvailable ? Colors.neutral_500 : Colors.neutral_300;

  return (
    <Column justifyContent="center" marginLeft={24}>
      <Row alignItems="center" gap={8}>
        <Text
          bold
          fontSize={22}
          maxWidth={175}
          whiteSpace="nowrap"
          overflow="hidden"
          textOverflow="ellipsis"
          opacity={isAvailable ? 1 : 0.5}
        >
          {fullname}
        </Text>

        <Row alignItems="center" justifyContent="center" gap={7}>
          <ProfessionalRating rating={rating} isAvailable={isAvailable} />
          <Box height={20} width={2} backgroundColor={Colors.neutral_600} />
          {isAvailable ? (
            <Link to={`/dashboard/professional/${id}`} style={{ textDecoration: 'none' }}>
              <Text bold color={Colors.secondary_500} fontSize={20}>
                Profile
              </Text>
            </Link>
          ) : (
            <Text bold color={Colors.secondary_200} fontSize={20}>
              Profile
            </Text>
          )}
        </Row>
      </Row>
      <Column>
        <Text color={unavailableColorText}>{UserProfession.getName(profession || '')}</Text>
        {isToday ? (
          <Text bold color={unavailableColorText}>
            Working:{' '}
            <Text
              color={isAvailable ? Colors.primary_500 : Colors.primary_200}
              style={{ fontWeight: 500 }}
            >
              TODAY
            </Text>
          </Text>
        ) : (
          <Text bold color={unavailableColorText}>
            Worked on:{' '}
            <Text
              color={unavailableColorText}
              style={{
                textTransform: 'capitalize',
              }}
            >
              {moment(datetime).format('ddd, MMM DD, YYYY')}
            </Text>
          </Text>
        )}
      </Column>
    </Column>
  );
};
